import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from 'projects/login/src/environments/environment';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

setupHs();

// eslint-disable-next-line no-console
bootstrapApplication(AppComponent, { ...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers] }).catch((err) => console.error(err));
function setupHs(): void {
  if (environment.name === 'production') {
    document.getElementById('hs-script-loader')?.setAttribute('src', '//js-eu1.hs-scripts.com/25758250.js');
  } else if (environment.name === 'staging' || environment.name === 'development' || environment.name === 'acceptance') {
    document.getElementById('hs-script-loader')?.setAttribute('src', '//js-eu1.hs-scripts.com/25788762.js');
  }
}
